import SessionEventProto from "../session-event-proto"

import {SESSION_PROJECTS_CHANGED} from "../../gd/bus/bus-event-type"
import ProjectSession from "../../model2/project/project-session"
import Company from "../../model2/company/company"
import asyncSessionLoader from "../../gd/data/async-session-loader"

export default class EventProjectsReset extends SessionEventProto {

    constructor(sessionEvent: any) {
        super(sessionEvent)
    }

    async process() {
        const projectsToUpdateSettings: ID[] = []
        let statuses: ID[] = []
        gd.session.projects.map((project: ProjectSession)=>{
            if (project.settings) projectsToUpdateSettings.push(project.id)
            if (project.taskStatusesOverride) statuses = statuses.concat(project.taskStatusesOverride)
        });

        gd.session.projects.resetAndKeepOldModels(this.data)
        gd.bus.triggerEvent(SESSION_PROJECTS_CHANGED)
        gd.session.templatesList.resetAndKeepOldModels(this.data ? this.data.filter((item: any)=>item.isTemplate && !item.parentId) : [])

        gd.session.projects.initTree()
        gd.session.templatesList.initTree()

        await asyncSessionLoader(gd.session.findMissing({
            projectsSettings: projectsToUpdateSettings,
            statuses: statuses
        }))

        gd.tree.companies.map((company: Company)=>{
            gd.tree.resetCompanyProjects(company.id)
        })
    }
}
